import { BodyResearchResponsible } from 'practice/view-models/research-responsible';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<BodyResearchResponsible, keyof BodyResearchResponsible>[] = [
  {
    id: 'responsible',
    label: 'Responsabile',
  },
  {
    id: 'practice',
    label: 'Pratica',
  },
  {
    id: 'service',
    label: 'Servizio',
  },
  {
    id: 'action',
    label: '',
  },
];
